var styleDataHash = "dec9677b";
const injectCss = (() => {
  var css = `.x6lC5{cursor:grab;user-select:none}.x6lC5:active{cursor:grabbing}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var panel_header_default = {
  "header": "x6lC5"
};
export {
  panel_header_default as default,
  injectCss
};
//# sourceMappingURL=panel-header-scss.js.map
